import { Typography } from "antd";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { CheckCircleOutlined } from "@ant-design/icons";
import { getPartnerConfig } from "../../config/genericPartners";
import { DocUpdateHeader, DocUpdateFooter } from "./components/DocUpdateLayout";
import "../SampleOrderForm/FormUnavailable.css";

const PREFIX = "form-unavailable";

const FormUnavailable = () => {
  const location = useLocation();
  const { partner = "" } = useParams<{ partner: string }>();
  const partnerConfig = getPartnerConfig(partner);

  if (!partnerConfig) return <Navigate to="/not-found" replace />;

  const reason = location.state?.reason || "unavailable";
  const requestNumber = location.state?.requestNumber;
  const isSuccess = reason === "success";
  const title = isSuccess ? "Request Submitted" : "Sample Request Form";
  const messageText = isSuccess
    ? `Your sample request${requestNumber ? ` (#${requestNumber})` : ""} has been submitted successfully.`
    : "This form has expired or is no longer available.";

  return (
    <div className={`${PREFIX}-container`}>
      <DocUpdateHeader prefix={PREFIX} />

      <main className={`${PREFIX}-main`}>
        <Typography.Title className={`${PREFIX}-title`}>{title}</Typography.Title>

        <div className={`${PREFIX}-message`}>
          <div className={`${PREFIX}-icon`}>
            {isSuccess ? (
              <div className="icon-square icon-success">
                <div className="icon-circle icon-circle-success">
                  <CheckCircleOutlined style={{ color: "white", fontSize: 16 }} />
                </div>
              </div>
            ) : (
              <div className="icon-square">
                <div className="icon-circle">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            )}
          </div>
          <Typography.Text className={`${PREFIX}-text`}>{messageText}</Typography.Text>
          {isSuccess && (
            <Typography.Text className={`${PREFIX}-subtext`}>
              You will receive a confirmation via SMS shortly.
            </Typography.Text>
          )}
        </div>
      </main>

      <DocUpdateFooter prefix={PREFIX} />
    </div>
  );
};

export default FormUnavailable;
